import { BLOCK_CLASSES as t } from "../../constants.js";
import { defineAttrs as l } from "../../utils/typed-attrs.js";
import { stylable as e } from "../decorators/stylable.js";
const o = l({
  type: { default: "callout" }
}), n = e({
  inline: !1,
  content: "(block | list)*",
  group: "block",
  selectable: !1,
  attrs: o,
  parseDOM: [{ tag: `.${t.callout}` }],
  toDOM(a) {
    return [
      "div",
      {
        class: `${t.callout}`,
        "data-insertable": "true"
      },
      0
    ];
  }
});
export {
  n as calloutSpec
};
